class KitSelector extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', (event) => {
      const card = event.target.closest('[data-option-value-id]');
      if (!card || card.disabled) return;
      const selector = `#variant-selects-${this.dataset.sectionId} [data-option-value-id="${card.dataset.optionValueId}"]`;
      const nativeInput = document.querySelector(selector);
      if (nativeInput) nativeInput.click();
    });

    document.addEventListener('change', (event) => {
      const input = event.target.closest(`#variant-selects-${this.dataset.sectionId} [data-option-value-id]`);
      if (!input) return;
      this.querySelectorAll('[data-option-value-id]').forEach((card) => {
        const selected = card.dataset.optionValueId === input.dataset.optionValueId;
        card.classList.toggle('is-selected', selected);
        card.setAttribute('aria-pressed', String(selected));
      });
    });
  }
}

class FreeGifts extends HTMLElement {
  connectedCallback() {
    const rail = this.querySelector('.custom-pdp__gift-rail');
    this.querySelector('.custom-pdp__rail-button--previous')?.addEventListener('click', () => rail.scrollBy({ left: -rail.clientWidth, behavior: 'smooth' }));
    this.querySelector('.custom-pdp__rail-button--next')?.addEventListener('click', () => rail.scrollBy({ left: rail.clientWidth, behavior: 'smooth' }));
  }
}

if (!customElements.get('kit-selector')) customElements.define('kit-selector', KitSelector);
if (!customElements.get('free-gifts')) customElements.define('free-gifts', FreeGifts);
